module.exports = __webpack_public_path__ + "img/ziti_02.7834cbc4.png";